import Box from "@mui/material/Box";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import dayjs from "dayjs";
import { useEffect, useState } from "react";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import bookclosurecss from "../../../myfin_v2/css/bookclosure.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import { Button } from "../../../myfin_v2/elements/Button";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import { ReactComponent as CalenderIcon } from "../../../myfin_v2/assets/icons/calender.svg";

const CreateFsModal = (props) => {
  const {
    open,
    handleClose,
    handleChangeValue,
    allCompany,
    selectedIr,
    uploadPreset,
    uploadPresetID,
    handleSubmitFs,
    workspaceData,
    ProjectName,
    fsData,
    projectsData,
    setUploadPresetId,
    consolList,          // ✅ NEW: received from parent (allpreconsoldata)
  } = props;

  const [parentOpt, setParentOpt] = useState([]);
  const [irOpt, setIROpt] = useState([]);
  const [presetOpts, setPresetOpts] = useState([]);
  const [currentFY, setCurrentFY] = useState(null);
  const [previousFY, setPreviousFY] = useState(null);
  const [selectedOption, setSelectedOption] = useState("uploadPreset");
  const [existingConsolOpts, setExistingConsolOpts] = useState([]);

  // ✅ Populate Investment Register options
  useEffect(() => {
    if (selectedIr?.length > 0) {
      const opt2 = selectedIr.map((det) => ({
        label: det.name,
        value: det._id,
      }));
      setIROpt(opt2);
    } else {
      setIROpt([]);
    }
  }, [selectedIr]);

  // ✅ Populate Preset options
  useEffect(() => {
    if (projectsData?.length > 0) {
      const options = projectsData.map((det) => ({
        label: det.project_name,
        value: det._id,
      }));
      setPresetOpts(options);
    }
  }, [projectsData]);

  // ✅ Populate Existing Consol options from consolList prop
  useEffect(() => {
    if (consolList?.length > 0) {
      const options = consolList.map((det) => ({
        label: det.name,
        value: det._id,
      }));
      setExistingConsolOpts(options);
    } else {
      setExistingConsolOpts([]);
    }
  }, [consolList]);


  useEffect(() => {
    if (allCompany?.length > 0) {
      const opt1 = allCompany.map((det) => ({
        label: det.company_name,
        value: det._id,
      }));
      setParentOpt(opt1);
    }
  }, [allCompany]);

  const handleRadioChange = (value) => {
  setSelectedOption(value);

  if (value === "uploadPreset") {
    handleChangeValue("standalone", "FSType"); 
    handleChangeValue("", "consolID");
  } else {
    handleChangeValue("consol", "FSType");   
    setUploadPresetId("");
    handleChangeValue("", "consolID");
  }
};

  return (
    <>
      {open && (
        <Modal
          class_="create-consol-fs-backdrop"
          title="Create Consol FS"
          bodycss={commoncss.unsetPadding}
          width="40%"
          headerActions={
            <CloseIcon onClick={handleClose} className="clickable" />
          }
          onClose={() => console.log("Modal Closed")}
          footerActions={
            <>
              <Button
                btnColor={buttoncss.secondary}
                onClick={handleClose}
                label="Cancel"
              />
              <Button
                btnColor={buttoncss.primary}
                label="Create Consol FS"
                onClick={handleSubmitFs}
              />
            </>
          }
        >
          <div className={commoncss.pd1530} style={{ borderRadius: "20px" }}>
            <style>
              {`
                .create-consol-fs-backdrop > div {
                   overflow: visible !important;
                   border-radius: 20px !important;
                }
                .create-consol-fs-backdrop > div > div:nth-child(2) {
                   overflow: visible !important;
                }
                .create-consol-fs-backdrop > div > div:first-child {
                   border-top-left-radius: 20px !important;
                   border-top-right-radius: 20px !important;
                }
                .create-consol-fs-backdrop > div > div:last-child {
                   border-bottom-left-radius: 20px !important;
                   border-bottom-right-radius: 20px !important;
                }

                /* Hide scrollbars but keep functionality */
                .create-consol-fs-backdrop ::-webkit-scrollbar {
                   display: none;
                }
                .create-consol-fs-backdrop {
                   -ms-overflow-style: none;
                   scrollbar-width: none;
                }
                .create-consol-fs-backdrop * {
                   -ms-overflow-style: none;
                   scrollbar-width: none;
                }

                /* Match font color and weight for all fields in modal */
                .create-consol-fs-backdrop input {
                   color: #205a46 !important;
                   font-weight: 500 !important;
                }
              `}
            </style>

            {/* Consol Name */}
            <InputGroup
              class_="mb-3"
              label="Consol Name"
              inputs={[
                <input
                  key="consol_name"
                  name="tag"
                  placeholder="Enter Consol Name"
                  onChange={(e) => handleChangeValue(e.target.value, "consol_name")}
                  value={fsData?.consol_name || ""}
                  style={{ color: "#205a46", fontWeight: "500" }}
                />,
              ]}
            />

            {/* Parent Company */}
            <div className="mb-3" style={{ position: "relative", zIndex: 50 }}>
              <Dropdown
                label="Parent Company"
                options={parentOpt}
                onSelect={(opt) => handleChangeValue(opt.value, "parent_company")}
                placeHolder="Select Parent Company"
                searchable={true}
                selValue={fsData?.parent_company}
              />
            </div>

            {/* Investment Register */}
            <div className="mb-3" style={{ position: "relative", zIndex: 40 }}>
              <Dropdown
                label="Investment Register"
                options={irOpt}
                onSelect={(opt) => handleChangeValue(opt.value, "link_ir")}
                placeHolder="Select Investment Register"
                searchable={true}
                selValue={fsData?.link_ir}
              />
            </div>

        
            <div className="mb-3" style={{ position: "relative", zIndex: 35 }}>
              <div className="input-group-label mb-2">
                <span style={{ whiteSpace: "nowrap", paddingLeft: "5px" }}>Select an option</span>
                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="fsSelection"
                      value="uploadPreset"
                      checked={selectedOption === "uploadPreset"}
                      onChange={(e) => handleRadioChange(e.target.value)}
                      style={{ marginRight: "8px", marginTop: "3px" }}
                    />
                    Upload Preset
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <input
                      type="radio"
                      name="fsSelection"
                      value="existingConsol"
                      checked={selectedOption === "existingConsol"}
                      onChange={(e) => handleRadioChange(e.target.value)}
                      style={{ marginRight: "8px", marginTop: "3px" }}
                    />
                    Select Existing Consol FS
                  </label>

                </div>
              </div>

              {/* ✅ Upload Preset Dropdown */}
              {selectedOption === "uploadPreset" && (
                <div style={{ position: "relative", zIndex: 30 }}>
                  <Dropdown
                    label=""
                    options={presetOpts}
                    onSelect={(opt) => {
                      setUploadPresetId(opt.value);
                    }}
                    placeHolder="Select Preset"
                    searchable={true}
                    selValue={uploadPresetID}
                  />
                </div>
              )}

              {/* ✅ Existing Consol Dropdown — sends consolID to parent */}
              {selectedOption === "existingConsol" && (
                <div style={{ position: "relative", zIndex: 30 }}>
                  <Dropdown
                    label=""
                    options={existingConsolOpts}
                    onSelect={(opt) => handleChangeValue(opt.value, "consolID")}
                    placeHolder="Select Existing Consol FS"
                    searchable={true}
                    selValue={fsData?.consolID}
                  />
                </div>
              )}
            </div>

            {/* Financial Year Pickers */}
            <InputGroup
              inputs={[
                <InputGroup
                  key="currentFY"
                  label="Current financial year"
                  inputs={[
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                          <MobileDatePicker
                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                            value={currentFY}
                            onChange={(value) => {
                              if (!value) return;
                              setCurrentFY(value);
                              const formatted = value.format("YYYY-MM-DD");
                              console.log("Current FY:", formatted);
                              handleChangeValue(formatted, "current_yr");
                            }}
                            format="DD-MMM-YYYY"
                            slotProps={{
                              textField: {
                                InputProps: { disableUnderline: true },
                                sx: { 
                                  "& fieldset": { border: "none" },
                                  "& .MuiInputBase-root": { 
                                    padding: 0,
                                    height: "37px",
                                    border: "1px solid #c2e6d1",
                                    backgroundColor: "#f4faf5",
                                    borderRadius: "10px",
                                    overflow: "hidden"
                                  },
                                  "& .MuiInputBase-input": { 
                                    padding: "8px 30px 8px 10px",
                                    fontSize: "13px",
                                    color: "#205a46",
                                    fontWeight: "500",
                                    height: "auto"
                                  }
                                },
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div style={{ pointerEvents: "none" }}>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                            style={{ cursor: "pointer", pointerEvents: "auto" }}
                          />
                        </span>
                      </div>
                    </>,
                  ]}
                />,

                <InputGroup
                  key="previousFY"
                  label="Previous financial year"
                  inputs={[
                    <>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                          <MobileDatePicker
                            className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                            value={previousFY}
                            onChange={(value) => {
                              if (!value) return;
                              setPreviousFY(value);
                              const formatted = value.format("YYYY-MM-DD");
                              console.log("Previous FY:", formatted);
                              handleChangeValue(formatted, "previous_yr");
                            }}
                            format="DD-MMM-YYYY"
                            slotProps={{
                              textField: {
                                InputProps: { disableUnderline: true },
                                sx: { 
                                  "& fieldset": { border: "none" },
                                  "& .MuiInputBase-root": { 
                                    padding: 0,
                                    height: "37px",
                                    border: "1px solid #c2e6d1",
                                    backgroundColor: "#f4faf5",
                                    borderRadius: "10px",
                                    overflow: "hidden"
                                  },
                                  "& .MuiInputBase-input": { 
                                    padding: "8px 30px 8px 10px",
                                    fontSize: "13px",
                                    color: "#205a46",
                                    fontWeight: "500",
                                    height: "auto"
                                  }
                                },
                              },
                            }}
                          />
                        </DemoContainer>
                      </LocalizationProvider>
                      <div style={{ pointerEvents: "none" }}>
                        <span className="icon">
                          <CalenderIcon
                            className="vaMiddle"
                            width={20}
                            height={20}
                            style={{ cursor: "pointer", pointerEvents: "auto" }}
                          />
                        </span>
                      </div>
                    </>,
                  ]}
                />,
              ]}
            />

          </div>
        </Modal>
      )}
    </>
  );
};

export default CreateFsModal;